module.exports = __webpack_public_path__ + "static/media/cert_117.9fc5c0ce.jpg";